import { render, staticRenderFns } from "./FollowingProductionCalendarView.vue?vue&type=template&id=2c88b716&"
import script from "./FollowingProductionCalendarView.vue?vue&type=script&lang=js&"
export * from "./FollowingProductionCalendarView.vue?vue&type=script&lang=js&"
import style0 from "./FollowingProductionCalendarView.vue?vue&type=style&index=0&id=2c88b716&prod&lang=scss&"
import style1 from "./FollowingProductionCalendarView.vue?vue&type=style&index=1&id=2c88b716&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports